import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import Session from 'supertokens-web-js/recipe/session';
import { PlatformRouteNames } from './route-names';
import PlatformLayout from '../views/PlatformLayout.vue';
import LoginPage from '../pages/LoginPage.vue';
import ActivityDashboard from '../pages/ActivityDashboard.vue';
import AnalyticsPage from '../pages/AnalyticsPage.vue';
import BusinessView from '../pages/BusinessView.vue';
import LeadsWorkspace from '../pages/LeadsWorkspace.vue';

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: PlatformRouteNames.Login,
    component: LoginPage,
  },
  {
    path: '/',
    component: PlatformLayout,
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: PlatformRouteNames.Activity,
        component: ActivityDashboard,
      },
      {
        path: 'analytics',
        name: PlatformRouteNames.Analytics,
        component: AnalyticsPage,
      },
      {
        path: 'business/:bid',
        name: PlatformRouteNames.BusinessView,
        component: BusinessView,
        props: true,
      },
      {
        path: 'crm',
        name: PlatformRouteNames.Crm,
        component: LeadsWorkspace,
      },
      {
        // Tasks now live inside the leads workspace; keep old links working
        path: 'reminders',
        redirect: { name: PlatformRouteNames.Crm, query: { tab: 'calendar' } },
      },
    ],
  },
];

export const createRouterObject = () => {
  const router = createRouter({
    history: createWebHistory(),
    routes,
  });

  router.beforeEach(async (to) => {
    if (to.matched.some((r) => r.meta.requiresAuth)) {
      const hasSession = await Session.doesSessionExist();
      if (!hasSession) {
        return { name: PlatformRouteNames.Login };
      }
    }

    if (to.name === PlatformRouteNames.Login) {
      const hasSession = await Session.doesSessionExist();
      if (hasSession) {
        return { name: PlatformRouteNames.Activity };
      }
    }
  });

  return router;
};
